<template>
    <lib-pricing
        v-model="selection"
        v-slot:default="props"
    >
        <actions-widget
            :can-purchase="props.canPurchase"
            @free-trial="submitCart(props.cart, 'trial')"
            @purchase="submitCart(props.cart, 'full')"
        ></actions-widget>
    </lib-pricing>
</template>

<script>
import ActionsWidget from "./ActionsWidget";
import LibPricing from "./LibPricing";

export default {
    name: "PricingPage",
    components: {ActionsWidget, LibPricing},
    data() {
        return {
            selection: {
                ahas: 1,
                plans: 0,
                comboAhas: 0,
                comboPlans: 0,
            },
        }
    },
    created() {
        jQuery.getJSON("/get-cart", {}, (data) => {
            this.loggedIn = data.loggedIn;
            if (data.cart !== null) {
                if (data.cart.ahas === "single") {
                    this.selection.ahas = 0;
                } else if (data.cart.ahas === "basic") {
                    this.selection.ahas = 1;
                    this.selection.comboAhas = 0;
                } else if (data.cart.ahas === "project") {
                    this.selection.ahas = 2;
                    this.selection.comboAhas = 1;
                } else if (data.cart.ahas === "business") {
                    this.selection.ahas = 3;
                    this.selection.comboAhas = 2;
                }
                if (data.cart.plans === "basic") {
                    this.selection.plans = 0;
                    this.selection.comboPlans = 0;
                } else if (data.cart.plans === "project") {
                    this.selection.plans = 1;
                    this.selection.comboPlans = 1;
                } else if (data.cart.plans === "business") {
                    this.selection.plans = 2;
                    this.selection.comboPlans = 2;
                }
            }
        })
    },
    methods: {
        submitCart: function(cart, trialOrFull) {
            const data = "cart=" + JSON.stringify(cart);
            jQuery.post('/save-cart', data, (responses) => {
                if (this.loggedIn) {
                    if (trialOrFull === 'trial') {
                        window.location.href = '/application';
                    } else {
                        window.location.href = '/application#/api/billing/checkout?type=renew';
                    }
                } else {
                  if(trialOrFull === 'trial') {
                    window.location.href = '/free-trial';
                  }
                  else {
                    window.location.href = '/register';
                  }
                }
            });
        },
    }
}
</script>

<style scoped>

</style>